import { SolutionTag } from '@luminovo/api-contracts';
import { isPresent } from '@luminovo/commons';

import { Solution, SolutionStatus } from '../../types';
import { extractSolutionStatus } from './extractSolutionStatus';

export function extractAvailabilityStatus(solution: Pick<Solution, 'solutionTags' | 'availability'>): SolutionStatus {
    if (!isPresent(solution.availability)) {
        return SolutionStatus.Error;
    }

    const availabilitySolutionTags = solution.solutionTags.filter(
        (tag) =>
            tag.tag === SolutionTag.LongLeadTime ||
            tag.tag === SolutionTag.Unavailable ||
            tag.tag === SolutionTag.UnknownLeadTime,
    );
    return extractSolutionStatus({ solutionTags: availabilitySolutionTags }, 'original');
}
